export class ReviewGroup {
    // default base values
    description: string;
    user_id: number;
    status?: number;
    id?: number;

    // defined values on filtered group
    //review_percentage: number;
    //order_count: number;
    
    // totals from filter
    review_total: number;
    reviewed: number;
    balance: number;

    // get data with custom filter
    review_calc_id: number;
    last_review_calc_id: number;

    // datetime
    created_at: Date;
    updated_at: Date;

    constructor(partial: Partial<ReviewGroup>) {
        // this.review_percentage = partial.review_percentage;
        // this.order_count = partial.order_count;

        this.review_total = partial.review_total;
        this.reviewed = partial.reviewed;
        this.balance = partial.balance;

        this.user_id = partial.user_id;
        this.status = partial.status || 0;
        this.review_calc_id = partial.review_calc_id || 0;
        this.last_review_calc_id = partial.last_review_calc_id || 0;
    }

    validate = (): boolean => !!this.description;
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/review-group.model.ts